import { defaultBahamutProviderConfiguration } from '../default-constants';

export const SILK_SWAP_BAHAMUT_CONTRACT_ADDRESS = '0xF660558a4757Fb5953d269FF32E228Ae3d5f6c68';

export const SILK_SWAP_BAHAMUT_PROVIDER_CONFIGURATION = defaultBahamutProviderConfiguration;
